import { useTheme } from '@mui/material'
import React, { ComponentPropsWithRef } from 'react'
type Props = ComponentPropsWithRef<'div'>
export const Container = (p: Props) => {
    const { className, ...rest } = p
    const muiTheme = useTheme()
    return (
        // 1) Scroll inside scroll:  h-screen >>> h-full(codepen not transposable!),h-dvh (like index.hmtm),h-lvh, min-hs-screen
        // 2) display flex > block, to allow one child to grow with scroll
        // 3) flex-grow > h-screen, to handle overflow with white bg and the button can be pushed to bottom
        // 4) w-full, to allow the container to stay at the full width of the screen, 
        // no matter the current statements width
        <div className="max-w-2xl mx-auto flex flex-col flex-grow w-full"
            style={{
                backgroundColor: muiTheme.palette.background.default,
            }}
        >
            {p.children}
        </div>
    )
}
